export default "__VITE_ASSET__Cvzu6yU0__"